// Material UI
import { makeStyles } from '@material-ui/core';

export default makeStyles({
  root: {
    height: 60,
    width: 134,
  },
});
